import { render, staticRenderFns } from "./edit_business_property.vue?vue&type=template&id=0efaffe3&scoped=true&"
import script from "./edit_business_property.vue?vue&type=script&lang=js&"
export * from "./edit_business_property.vue?vue&type=script&lang=js&"
import style0 from "./edit_business_property.vue?vue&type=style&index=0&id=0efaffe3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efaffe3",
  null
  
)

export default component.exports